import axios from "axios";
import { fireConversion } from "../components/TrackingScripts";

// Resolve backend URL safely for BOTH preview and production builds.
// If the build-time URL doesn't match the current window host (e.g. the build was
// done against the preview domain but is now served from peptidoscostarica.com),
// fall back to same-origin so /api/* hits the ingress on the same hostname.
// This avoids CORS issues + ensures httpOnly cookies are sent.
const RAW = process.env.REACT_APP_BACKEND_URL || "";
const resolveBackendUrl = () => {
  if (typeof window === "undefined") return RAW;
  if (!RAW) return window.location.origin;
  try {
    const buildHost = new URL(RAW).hostname;
    const currentHost = window.location.hostname;
    // En react-snap (localhost) usamos RAW para que los errores sean CORS (silenciosos)
    // y no HTML de localhost que rompe el stream de pre-rendering.
    // Solo fallback a same-origin cuando el dominio activo es diferente al del build
    // Y no es un entorno local (localhost / 127.0.0.1).
    if (buildHost && buildHost !== currentHost &&
        currentHost !== "localhost" && currentHost !== "127.0.0.1") {
      return window.location.origin;
    }
    return RAW;
  } catch (e) {
    return window.location.origin;
  }
};

export const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;

// All auth state lives in an httpOnly cookie set by the backend on /api/auth/login.
// `withCredentials: true` makes axios send the cookie automatically — no token in localStorage.
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Rechazar respuestas no-JSON (evita que react-snap o errores de red pasen HTML como datos)
api.interceptors.response.use(
  (response) => {
    const ct = response.headers["content-type"] || "";
    if (!ct.includes("application/json") && !ct.includes("text/plain")) {
      return Promise.reject(new Error(`[api] Non-JSON response (${ct})`));
    }
    return response;
  },
  (error) => Promise.reject(error)
);

export const trackWhatsApp = (page, context = "") => {
  // Internal click counter — fire-and-forget. Log network failures so they're debuggable.
  api.post("/track/whatsapp", { page, context }).catch((err) => {
    console.warn("[trackWhatsApp] failed:", err?.message);
  });
  // External pixels / GTM / GA4
  fireConversion("Contact", { page, context, channel: "whatsapp" });
  fireConversion("whatsapp_click", { page, context });
};
